export enum FormFieldType {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Date = 'date',
  DateTime = 'datetime_local',
  Select = 'select',
  IconSelect = 'icon-select',
  MultiSelect = 'multi_select',
  LinkedGroupedMultiSelect = 'linked_grouped_multi_select',
  Checkbox = 'checkbox',
  Divider = 'divider',
  Typography = 'typography ',
  Button = 'button',
  LinkedSelect = 'linkedSelect ',
  IconButton = 'iconButton',
  FloatNumber = 'float_number',
  DateWithInfinity = 'dateWithInfinity',
  Duration = 'duration',
  LocalTime = 'local_time',
  Accordion = 'accordion',
  File = 'file',
}
